import React,{useState,useEffect} from 'react'
import EssLayout from '../../../../layout/components/ESSLayout'
import { Link } from 'react-router-dom'
import MonthlyDateSelect from '../../../../components/AppInput/MonthlyDateSelect'
import essTeamServices from '../../EssTeam/essTeamServices';
import moment from 'moment';

function ESSTeamWorkReportPage() {

    const [workReportList, setWorkReportList] = useState(null);
    const [filter, setFilter] = useState(null);

    const getWorkReport = () => {
        essTeamServices.getTeamWorkReportList(filter).then(res => {
            setWorkReportList(res.data);
        }).catch(error => {
            console.log(error);
        });
    };

    useEffect(() => {
        getWorkReport();
    }, [filter]);

    return (
        <EssLayout>
            <div className='row'>
                <div className='col-md-6'>
                    <span className='fw-bold me-2'>Team Work report</span>
                    <Link to={"/work-report"} className='btn btn-outline-primary ms-5'>Show My Work Report</Link>
                </div>
                <div className='col-md-6'>
                    <span className='float-end mt-2'><MonthlyDateSelect filter={filter} setFilter={setFilter} /></span>
                </div>
            </div>

            {/* Report List Section */}
            <div className='row mt-2'>
                <div className='col-12'>
                    {/* Desktop Header: Hidden on Mobile */}
                    <div className='d-none d-md-flex row mx-0 py-3 bg-dark text-white rounded-top fw-bold small'>
                        <div className='col-md-1 ps-4'>ID</div>
                        <div className='col-md-2'>DATE</div>
                        <div className='col-md-6'>REPORT / DETAILS</div>
                        <div className='col-md-3 text-end pe-4'>Employee</div>
                    </div>
                    {/* List Content */}
                    <div className='bg-white shadow-sm rounded-bottom'>
                        {workReportList && workReportList.length > 0 ? (
                            workReportList.map((report, index) => (
                                <div key={report.id} 
                                    className={`row mx-0 py-3 align-items-center border-bottom hover-bg-light ${index % 2 === 0 ? 'bg-white' : 'bg-light-subtle'}`}>
                                    {/* ID Column */}
                                    <div className='col-12 col-md-1 ps-md-4 mb-2 mb-md-0'>
                                        <span className='d-md-none fw-bold text-muted me-2'>ID:</span>
                                        <span className='text-muted small'>#{report.id}</span>
                                    </div>
                                    {/* Date Column */}
                                    <div className='col-12 col-md-2 mb-2 mb-md-0'>
                                        <div className='d-md-none text-muted small'>Report Date</div>
                                        <div className='fw-semibold'>
                                            {moment(report.updated_at).format("DD MMM YYYY")}
                                        </div>
                                        <small className='text-muted'>{moment(report.updated_at).format("h:mm A")}</small>
                                    </div>
                                    {/* Report Text Column */}
                                    <div className='col-12 col-md-6 mb-3 mb-md-0'>
                                        <div className='d-md-none text-muted small'>Activity Detail</div>
                                        {report.imageUrl !== null &&
                                        <div className=''>
                                            <a href={report.imageUrl} target='_blank'>
                                            <img src={report.imageUrl} style={{maxHeight:200,maxWidth:200}} className="img-thumbnail" />
                                            </a>
                                        </div>
                                        }
                                        <div className='text-dark' style={{ whiteSpace: 'pre-line' }}>
                                            {report.report}
                                        </div>
                                        
                                    </div>
                                    {/* Employee Name */}
                                    <div className='col-12 col-md-3 text-md-end pe-md-4'>
                                        <div><span class="blockquote-footer fw-bold"> {report.employeeName}</span></div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className='p-5 text-center text-muted'>
                                <i className="bi bi-journal-x d-block fs-1 mb-2 opacity-25"></i>
                                No work reports found.
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </EssLayout>
    )
}

export default ESSTeamWorkReportPage